module.exports = __webpack_public_path__ + "img/panel.2d6ada1a.png";